<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Įkaito davėjai</h3>

    <hipoteka-asmenys :asmuo-role="asmuoRole" :readonly="isReadonlyForm" />

    <v-footer class="form-footer" :sticky="true">
      <v-spacer></v-spacer>
      <el-button v-if="!isReadonlyForm" primary @click.native="checkErrors()"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import checkErrors from '../../mixins/checkErrors'
import HipotekaAsmenys from './HipotekaAsmenys'

export default {
  name: 'HipotekaIkaitoDavejai',
  components: {
    HipotekaAsmenys,
  },
  mixins: [checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['hipotekaReadonly']),
    asmuoRole() {
      return HipotekaMap['asmenysRoles'].davejas
    },
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
